<div
  class="px-md py-sm hover:bg-components-background-neutral-lighter group/item gap-xxs flex items-center justify-between hover:cursor-pointer hover:rounded-b-md"
  (click)="toggleCheckbox()"
>
  <div class="gap-xs flex items-center">
    <hlm-checkbox [checked]="isChecked(item().id, formcontrol())" />
    <span class="component-medium-medium">
      {{ item().nom }}
    </span>
  </div>

  <ng-content />
</div>
